import Box from '@mui/material/Box';
import { ReactNode } from 'react';

import { SelectLabel, SelectLabelProps } from './SelectLabel';

interface SelectIconLabelProps extends SelectLabelProps {
	icon?: ReactNode;
	endIcon?: ReactNode;
}

export const SelectIconLabel = ({
	icon,
	endIcon,
	...propsRest
}: SelectIconLabelProps) => (
	<Box
		sx={{
			display: 'flex',
			alignItems: 'center',
			gap: 1,
		}}>
		{icon}
		<SelectLabel {...propsRest} />
		{endIcon}
	</Box>
);
